import { replaceParams } from '@dreryk/drerykweb-main-frontend';

import { createPath, GetSearchParams, useSearchParams } from './pathCreator';

export enum PatientPanelNavParams {
   PERSONAL_DATA = 'dane-osobowe',
   PATIENT_GROUPS = 'oznaczenia-pacjenta',
   MEDICAL_INFORMATION = 'dane-medyczne',
   VISITS_HISTORY = 'historia-wizyt',
   PRESCRIPTIONS_HISTORY = 'historia-recept',
   MEDICAL_DOCUMENT_REPOSITORY = 'repozytorium',
   CONSENTS_AND_AUTHORIZATION = 'zgody-i-upowaznienia',
}

export const PATIENTS_ENTRY_PATH = '/pacjenci';
export const LIST_PATIENTS_PATH = PATIENTS_ENTRY_PATH;
export const PATIENT_CREATE_PATH = `${PATIENTS_ENTRY_PATH}/dodaj-pacjenta`;
export const TEMPORARY_PATIENT_PATH = `${PATIENTS_ENTRY_PATH}/tymczasowy/:patientId`;
export const PATIENT_DATA_PATH = `${PATIENTS_ENTRY_PATH}/:patientId`;
const MEDICAL_DATA_PATH = `${PATIENTS_ENTRY_PATH}/:patientId/${PatientPanelNavParams.MEDICAL_INFORMATION}`;
const MEDICAL_DOCUMENT_REPOSITORY_PATH = `${PATIENTS_ENTRY_PATH}/:patientId/${PatientPanelNavParams.MEDICAL_DOCUMENT_REPOSITORY}`;
const PRESCRIPTIONS_HISTORY_PATH = `${PATIENTS_ENTRY_PATH}/:patientId/${PatientPanelNavParams.PRESCRIPTIONS_HISTORY}`;
const CONSENTS_AND_AUTHORIZATIONS_PATH = `${PATIENTS_ENTRY_PATH}/:patientId/${PatientPanelNavParams.CONSENTS_AND_AUTHORIZATION}`;
const CALENDAR_PATH = '/kalendarz';

export const getEntryPath = (): string => PATIENTS_ENTRY_PATH;

export const getListPath = (): string => PATIENTS_ENTRY_PATH;

export const getCreateFormPath = (): string => PATIENT_CREATE_PATH;

export const getDataPath = (patientId: number): string =>
   replaceParams(PATIENT_DATA_PATH, {
      patientId: patientId.toString(),
   });

export const getTemporaryDataPath = (patientId: number): string =>
   replaceParams(TEMPORARY_PATIENT_PATH, {
      patientId: patientId.toString(),
   });

const MEDICAL_DATA_CATEGORY_SEARCH_PARAM = 'kategoria';
const MEDICAL_DATA_ENTRY_SEARCH_PARAM = 'wpis';

export const getMedicalDataPath = (data: {
   params: {
      patientId: number;
   };
   searchParams: {
      category?: string;
      entryId?: number;
   };
}): string =>
   createPath(MEDICAL_DATA_PATH, data, {
      category: MEDICAL_DATA_CATEGORY_SEARCH_PARAM,
      entryId: MEDICAL_DATA_ENTRY_SEARCH_PARAM,
   });

export const useMedicalDataSearchParams = (): GetSearchParams<typeof getMedicalDataPath> =>
   useSearchParams<typeof getMedicalDataPath>({
      [MEDICAL_DATA_CATEGORY_SEARCH_PARAM]: 'category',
      [MEDICAL_DATA_ENTRY_SEARCH_PARAM]: 'entryId',
   });

const MEDICAL_DOCUMENT_SEARCH_PARAM = 'dokument';

export const getMedicalDocumentRepositoryPath = (data: {
   params: {
      patientId: number;
   };
   searchParams: {
      documentId?: number;
   };
}): string =>
   createPath(MEDICAL_DOCUMENT_REPOSITORY_PATH, data, {
      documentId: MEDICAL_DOCUMENT_SEARCH_PARAM,
   });

export const useMedicalDocumentRepositorySearchParams = (): GetSearchParams<typeof getMedicalDocumentRepositoryPath> =>
   useSearchParams<typeof getMedicalDocumentRepositoryPath>({
      [MEDICAL_DOCUMENT_SEARCH_PARAM]: 'documentId',
   });

export const getPrescriptionsHistoryPath = (patientId: number): string =>
   replaceParams(PRESCRIPTIONS_HISTORY_PATH, { patientId: patientId.toString() });

export const getConsentsAndAuthorizationsPath = (patientId: number): string =>
   replaceParams(CONSENTS_AND_AUTHORIZATIONS_PATH, { patientId: patientId.toString() });

export const getCalendarWithBookingModePath = (patientId: number): string =>
   `${CALENDAR_PATH}?zarejestruj=${patientId}`;
